import * as yup from 'yup';

export const UpdateSubjectFormValidation = yup.object().shape({
    id: yup.string().required(),
    status: yup.boolean().required(),
    description: yup.string().required('Descrição é obrigatória'),
    isCore: yup.bool().oneOf([true, false], 'Inválido').required('Obrigatório'),
    hasExam: yup.bool().oneOf([true, false], 'Inválido').required('Obrigatório'),
    isMonograph: yup.bool().oneOf([true, false], 'Inválido'),
    idScientificArea: yup.string().required('Área cientifica Obrigatória'),
    idPrecedence: yup
        .string()
        .notOneOf([yup.ref('id')], 'A precedência não pode ser igual a propria disciplina.')
        .nullable()
});